import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { Container, Card, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BASE_URL } from "../../constants";
import "../../CommonCSS/SocietyCSS.css";
import { Textarea } from "@chakra-ui/react";


const Notice = () => {
  const [formData, setFormData] = useState({
    section_id: '',
    std_id: '',
    div_id: '',
    validTill: "",
    notice_type: "GEN",
    noticeText: "",
    noticeText_Hindi: "",
    noticeText_Marathi: "",
    noticeText_Gujarati: "",
    noticeText_Urdu: "",
    speechText: "",
    fileType: "",
    savedFilename: "",
    pdfFile: null,
  });

  const [pdfURL, setPdfURL] = useState(null);
  const [isListening, setIsListening] = useState(false);
  const [noticeFiles, setNoticeFiles] = useState([]);
  const [ddlSections, setDdlSections] = useState([]);
  const [ddlStandards, setDdlStandards] = useState([]);
  const [ddlDivisions, setDdlDivisions] = useState([]);

  // const [fileName, setFileName] = useState("");

  const fileInputRef = useRef(null);
  const recognitionRef = useRef(null);

  //  let recognition;

  useEffect(() => {
    loadDropdowns();
  }, []);

  const loadDropdowns = async () => {
    try {
      const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSections(sec.data);
    } catch (err) {
      console.error(err);
    }
  };

  /// To Populate Standard on chnage of Section
  useEffect(() => {

    if (!formData.section_id) return;

    const fetchStandards = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ddl_standards`, { params: { p_Section_Id: formData.section_id } });
        setDdlStandards(res.data || []);
      } catch (error) {
        console.error("Error fetching subgroups:", error);
      }
    };

    fetchStandards();

  }, [formData.section_id]);

  /// To Populate Division on change of Standard
  useEffect(() => {

    if (!formData.std_id) return;

    const fetchDivision = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ddl_division`, { params: { p_Std_Id: formData.std_id } });
        setDdlDivisions(res.data || []);
      } catch (error) {
        console.error("Error fetching subgroups:", error);
      }
    };

    fetchDivision();

  }, [formData.std_id]);


  useEffect(() => {

    if ("webkitSpeechRecognition" in window) {
      const recognition = new window.webkitSpeechRecognition();
      recognition.continuous = true;
      recognition.interimResults = false;

      recognition.onresult = (event) => {
        const transcript = event.results[event.results.length - 1][0].transcript;
        setFormData((prev) => ({
          ...prev,
          speechText: prev.speechText + " " + transcript
        }));
      };

      recognition.onerror = () => setIsListening(false);

      recognition.onend = () => {
        // When speech recognition fully stops
        setIsListening(false);
      };

      recognitionRef.current = recognition;
    }

  }, []);

  const startListening = () => {
    if (!recognitionRef.current) {
      alert("Speech Recognition not supported");
      return;
    }
    setIsListening(true);
    recognitionRef.current.start();
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
    }
    setIsListening(false);
  };

  // Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // PDF Upload Handler
  // const handleFileUpload = (e) => {

  //   const file = e.target.files[0];
  //   if (!file) return;

  //   setNoticeFiles(e.target.files);
  //   setFileName(file.name);

  //   const url = URL.createObjectURL(file);
  //   setPdfURL(url);

  // };

  const handleFileUpload = (e) => {

    const file = e.target.files[0];
    if (!file) return;

    setNoticeFiles(e.target.files);

    // setFileName(file.name);

    const previewURL = URL.createObjectURL(file);
    setPdfURL(previewURL);

    setFormData(prev => ({
      ...prev,
      pdfFile: file
    }));

  };

  const handleMoveSpeachToTextBox = async () => {

    setFormData(prev => ({
      ...prev,
      noticeText:
        prev.noticeText
          ? prev.noticeText + "\n" + prev.speechText   // append with new line
          : prev.speechText,                            // or replace if empty
      speechText: ""
    }));

  };

  const handleEmptySpeechText = async () => {

    const confirmClear = window.confirm("Sure you want to move clear Speech Text ?");
    if (!confirmClear) return;

    setFormData(prev => ({
      ...prev,
      speechText: "",
    }));

  };

  // Save Handler
  //   const handleSave = async () => {

  //     if (!formData.validTill) {
  //       alert("Please select Valid Till Date");
  //       return;
  //     }
  //     if (!formData.noticeText.trim()) {
  //       alert("Please enter Notice Text");
  //       return;
  //     }

  //     try {

  //       const tradefileinput = document.getElementById('formFileSm');
  //       let lv_savedFileName = '';

  //       /// if file is selected, first upload the file to a folder, get the saved file name
  //       if (tradefileinput) {
  //         const fileData = new FormData();
  //         for (let i = 0; i < noticeFiles.length; i++) {
  //           fileData.append('files', noticeFiles[i]);
  //         }
  //         const res = await axios.post(`${BASE_URL}/api/upload_notice`, fileData, {
  //           headers: {
  //             'Content-Type': 'multipart/form-data'
  //           }
  //         });
  //         res.data.files.forEach(f => {
  //           lv_savedFileName = f.savedName;
  //         });
  // console.log('lv_savedFileName => ', lv_savedFileName);
  //         if (lv_savedFileName) {
  //           setFormData(prev => ({
  //             ...prev,
  //             savedFilename: lv_savedFileName
  //           }));
  //         }
  //       }
  // console.log('formData.savedFilename => ', formData.savedFilename);
  //       const payload = {
  //         header: formData,
  //       };

  //       const result = await axios.post(`${BASE_URL}/api/save_notice`, payload);

  //       if (result.data.message === '1') {
  //         alert("Notice saved successfully!");
  //         clearPage();
  //       } else {
  //         alert('Unable to save Notice');
  //       }

  //     } catch (err) {
  //       alert('Error in saving Notice, ', err);
  //     }

  //   };

  const handleSave = async () => {

    try {
      // 1️⃣ Basic Validation
      if (!formData.validTill) {
        alert("Please select Valid Till Date");
        return;
      }
      if (!formData.noticeText.trim()) {
        alert("Please enter Notice Text");
        return;
      }

      // Convert both dates to comparable values
      const selectedDate = new Date(formData.validTill);
      const today = new Date();

      // Remove time (so comparison is clean)
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate <= today) {
        alert("Valid Till date must be greater than today's date.");
        return;
      }

      const confirmClear = window.confirm("Sure you want to Save and send Notice ?");

      console.log('save the file')

      if (!confirmClear) return;

      let lv_savedFileName = "";
      let lv_savedFileExt = "";

      // 2️⃣ If a file is selected → upload it first
      if (formData.pdfFile) {
        const fileData = new FormData();
        fileData.append("noticeFile", formData.pdfFile);

        const uploadRes = await axios.post(
          `${BASE_URL}/api/upload_Notice`,
          fileData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );

        lv_savedFileName = uploadRes.data.filename;
        lv_savedFileExt = lv_savedFileName.split(".").pop().toUpperCase();
      }
        // Extract file name from response
        // if (res?.data?.files?.length > 0) {
        //   lv_savedFileName = res.data.files[0].savedName;
        //   lv_savedFileExt = lv_savedFileName.substring(lv_savedFileName.lastIndexOf('.') + 1);
        //   if (lv_savedFileExt.toLocaleUpperCase() === 'PDF') lv_savedFileExt = 'PDF'; else lv_savedFileExt = 'IMG';
        // }
      // 3️⃣ Build Final Payload Manually
      const finalHeader = {
        ...formData,
        savedFilename: lv_savedFileName || formData.savedFilename,
        fileType: lv_savedFileExt || formData.fileType,
      };

      //      console.log("Final Payload Sent:", finalHeader);

      // 4️⃣ Save Notice
      const result = await axios.post(`${BASE_URL}/api/save_notice`, {
        header: finalHeader,
      });

      // 5️⃣ Server Response
      if (result.data.message === "1") {

        alert("Notice saved successfully!");
        clearPage();
      } else {
        alert("Unable to save Notice");
      }
    } catch (err) {
      console.error(err);
      alert("Error saving Notice");
    }
  };


  // Clear Handler
  const handleClear = () => {
    const confirmClear = window.confirm("Sure you want to clear ?");
    if (!confirmClear) return;

    clearPage();

  };

  const clearPage = () => {

    setFormData({
      notice_type: "GEN",
      validTill: "",
      noticeText: "",
      speechText: "",
      noticeText_Hindi: "",
      noticeText_Marathi: "",
      noticeText_Gujarati: "",
      noticeText_Urdu: "",
      fileType: "",
      savedFilename: "",
      pdfFile: null,
    });
    setPdfURL(null);

    if (fileInputRef.current) fileInputRef.current.value = null;

  }

  return (
    <Container fluid className="p-3">
      <Card className="p-4 shadow-sm">

        <Row className="mb-2">
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Section
              </InputGroup.Text>
              <select
                className="form-select"
                name="section_id"
                value={formData.section_id}
                onChange={handleChange}
              >

                <option value="">--Select Section--</option>
                {ddlSections.map(s => (
                  <option key={s.section_id} value={s.section_id}>{s.section_desc}</option>
                ))}

              </select>
            </InputGroup>
          </Col>
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Standard
              </InputGroup.Text>
              <select
                className="form-select"
                name="std_id"
                value={formData.std_id}
                // disabled={!isEditable}
                onChange={handleChange}
              >
                <option value="">--Select Acadamic Year--</option>
                {ddlStandards.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Division
              </InputGroup.Text>
              <select
                className="form-select"
                name="div_id"
                value={formData.div_id}
                // disabled={!isEditable}
                onChange={handleChange}
              >
                <option value="">--Select Current Div --</option>
                {ddlDivisions.map(div => (
                  <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                ))}

              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>
                Valid Till Date
              </InputGroup.Text>
              <Form.Control
                type="date"
                name="validTill"
                value={formData.validTill}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>
        </Row>

        {/* ======== Form Fields ======== */}
        <Row className="mb-3">

          <Col md={6}>
            <Form.Floating className="mb-3">
              <Form.Control
                as="textarea"
                style={{ height: "300px" }}
                name="noticeText"
                value={formData.noticeText}
                onChange={handleChange}
                placeholder="Type your notice here..."
              />
              <label className="fw-bold">Notice Text(English)</label>
              <div style={{ textAlign: "right", fontSize: "12px", color: "#555" }}>
                {formData.noticeText.length} characters
              </div>
            </Form.Floating>
          </Col>
          {/* Speech to Text Row */}
          <Col md={6}>
            <Form.Floating className="mb-3">
              <Form.Control
                as="textarea"
                style={{ height: "250px" }}
                name="speechText"
                value={formData.speechText}
                onChange={handleChange}
                readOnly
                placeholder="Speak your notice here..."
              />
              <label className="fw-bold">Speech To Text</label>
            </Form.Floating>
            <div className="mt-2">
              {!isListening ? (
                <Button variant="primary" onClick={startListening} className="me-2">
                  🎤 Start Listening
                </Button>
              ) : (
                <Button variant="danger" onClick={stopListening} className="me-2">
                  ⏹ Stop
                </Button>
              )}
              <Button variant="primary" onClick={handleMoveSpeachToTextBox} disabled={formData.speechText.length === 0} className="me-2">
                Move Text To Notice Text
              </Button>
              <Button variant="secondary" onClick={handleEmptySpeechText} disabled={formData.speechText.length === 0} className="me-2">
                Empty Speech Text
              </Button>
            </div>
          </Col>
        </Row>

        <Row className="mb-3">
          {/* Hindi Notice */}
          <Col md={6}>
            <Form.Floating className="mb-3">
              <Form.Control
                as="textarea"
                style={{ height: "300px" }}
                name="noticeText_Hindi"
                value={formData.noticeText_Hindi}
                onChange={handleChange}
                placeholder="Type your notice here..."
              />
              <label className="fw-bold">Notice Text (Hindi)</label>
              <div style={{ textAlign: "right", fontSize: "12px", color: "#555" }}>
                {formData.noticeText_Hindi.length} characters
              </div>
            </Form.Floating>
          </Col>

          <Col md={6}>
            {/* Marathi Notice */}
            <Form.Floating className="mb-3">
              <Form.Control
                as="textarea"
                style={{ height: "300px" }}
                name="noticeText_Marathi"
                value={formData.noticeText_Marathi}
                onChange={handleChange}
                placeholder="Type your notice here..."
              />
              <label className="fw-bold">Notice Text (Marathi)</label>
              <div style={{ textAlign: "right", fontSize: "12px", color: "#555" }}>
                {formData.noticeText_Marathi.length} characters
              </div>
            </Form.Floating>
          </Col>

        </Row>

        <Row className="mb-3">
          {/* Gujarati Notice */}
          <Col md={6}>
            <Form.Floating className="mb-3">
              <Form.Control
                as="textarea"
                style={{ height: "300px" }}
                name="noticeText_Gujarati"
                value={formData.noticeText_Gujarati}
                onChange={handleChange}
                placeholder="Type your notice here..."
              />
              <label className="fw-bold">Notice Text (Guarati)</label>
              <div style={{ textAlign: "right", fontSize: "12px", color: "#555" }}>
                {formData.noticeText_Gujarati.length} characters
              </div>
            </Form.Floating>
          </Col>

          {/* Urdu Notice */}
          <Col md={6}>
            <Form.Floating className="mb-3">
              <Form.Control
                as="textarea"
                style={{ height: "300px" }}
                name="noticeText_Urdu"
                value={formData.noticeText_Urdu}
                onChange={handleChange}
                placeholder="Type your notice here..."
              />
              <label className="fw-bold">Notice Text (Urdu)</label>
              <div style={{ textAlign: "right", fontSize: "12px", color: "#555" }}>
                {formData.noticeText_Urdu.length} characters
              </div>
            </Form.Floating>
          </Col>

        </Row>

        {/* <Row className="mb-3">

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "160px" }}>
                	Notice Text (Hindi):
              </InputGroup.Text>
              <input
                type="text"
                style={{ textAlign: 'left' }}
                className="form-control"
                name="notice_txt_1"
                value={formData.notice_txt_1}
              // disabled={!isEditable}
              // onChange={handleChange}
              />
            </InputGroup>
          </Col>
          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "160px" }}>
                	Notice Text (Urdu):
              </InputGroup.Text>
              <input
                type="text"
                style={{ textAlign: 'left' }}
                className="form-control"
                name="notice_txt_2"
                value={formData.notice_txt_2}
              // disabled={!isEditable}
              // onChange={handleChange}
              />
            </InputGroup>
          </Col>
          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "170px" }}>
                	Notice Text (Marathi):
              </InputGroup.Text>
              <input
                as="textarea"
                type="text"
                style={{ textAlign: 'left' }}
                className="form-control"
                rows="3"
                name="notice_txt_3"
                value={formData.notice_txt_3}
              // disabled={!isEditable}
              onChange={handleChange}
              />
            </InputGroup>
          </Col>
        </Row> */}


        <Row className="mb-3">

          {/* PDF Upload */}
          <Col md={6}>
            {/* <Form.Label>Select PDF File:</Form.Label> */}
            <Form.Control type="file" accept="application/pdf" onChange={handleFileUpload} ref={fileInputRef} id="formFileSm" />

            {pdfURL && (
              <div className="mt-3">
                <h6>PDF Preview:</h6>
                <iframe
                  src={pdfURL}
                  title="LC/BC Preview"
                  width="100%"
                  height="300px"
                  style={{ border: "1px solid #ccc" }}
                ></iframe>
              </div>
            )}
          </Col>



          {/* ======== Buttons ======== */}
          <Col md={3} className="justify-content-end">
            <Button variant="secondary" style={{ width: '100px' }} className="me-2" onClick={handleClear}>Clear </Button>
            <Button variant="success" style={{ width: '150px' }} className="me-2" onClick={handleSave}>Save Notice</Button>
          </Col>

        </Row>

        {/* ======== Buttons ======== */}
        {/* <Row className="mt-3 justify-content-end">
          <Col md="auto">
            <Button variant="secondary" className="me-2" onClick={handleClear}>
              Clear
            </Button>
            <Button variant="success" onClick={handleSave}>
              Save
            </Button>
          </Col>

        </Row> */}

      </Card>
    </Container>
  );
};

export default Notice;
